import { useDropzone } from 'react-dropzone'
import { memo, useEffect, useRef } from 'react'
import css from './audioDropzone.module.css'
import { ReactComponent as CancelIcon } from '../../../asserts/icons/xmark.svg'

interface IProps {
  onFile: (file: File) => void
  hasFile?: boolean
}

const Dropzone = (props: IProps) => {
  const firstRender = useRef(true)
  const { acceptedFiles, getRootProps, getInputProps, open } = useDropzone({
    maxFiles: 1,
    accept: { 'audio/mp3': ['.mp3'] },
  })

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
      return
    }

    props.onFile(acceptedFiles[0])
  }, [acceptedFiles])

  if (acceptedFiles[0]) {
    return (
      <div className={css.dropzone} style={{ cursor: 'auto' }}>
        <span>{acceptedFiles[0].name}</span>
        <CancelIcon className={css.cancel} fill="var(--gray)" onClick={open} />
      </div>
    )
  }

  return (
    <div {...getRootProps({ className: css.dropzone })}>
      <p>
        {props.hasFile
          ? 'Кликните или перетащите сюда аудиофайл для замены текущего'
          : 'Кликните или перетащите сюда аудио'}
      </p>
      <input {...getInputProps()} />
    </div>
  )
}

export default memo(Dropzone)
